import { i18n } from '@/i18n';
import { ContractPricingIssuer, ContractPricingType } from '@/services/requests/users/Users.types';
import { getFixedOrPercentPrice, getFixedPrice } from '@/utils/getFixedPrice';

type PricingType = Exclude<ContractPricingType, 'fixed'>;

export const formatIssuers = (issuers: ContractPricingIssuer[]) => {
  const allZero = issuers.every((issuer) => issuer.conditions?.[0].value.type === 'zero');
  const isEmpty = !issuers.length || !Array.isArray(issuers?.[0]?.conditions);
  const { t } = i18n.global;

  if (allZero || isEmpty) {
    return t('components.pricing.section.free');
  }

  return issuers.map((issuer) => {
    const { type, valuePercent } = issuer.conditions[0].value;
    const { symbol } = issuer.issuer;
    const typeHandler: Record<PricingType, () => string> = {
      zero: () => (issuers.length > 1 ? `${symbol}0` : t('components.pricing.section.free')),
      percent: () => `${valuePercent}%`,
      fixed_and_percent: () => getFixedOrPercentPrice(issuer, t('components.pricing.section.and')),
      lesser_of_fixed_or_percent: () => getFixedOrPercentPrice(issuer, t('components.pricing.section.max')),
      greater_of_fixed_or_percent: () => getFixedOrPercentPrice(issuer, t('components.pricing.section.min')),
    };

    if (type in typeHandler) return typeHandler[type as PricingType]();

    return getFixedPrice(issuer);
  }).join('/');
};
